<style lang="scss">
.telemedicine-buttons {
@apply absolute;
right: 0;
top: -30px;
}
</style>

<template>
  <div>
    <div
      v-show="ui.isStarted"
      v-if="!destroy"
      ref="telemedicine-container"
      class="telemedicine"
      @click="!isCurrentPath && $router.push(path)"
      @mouseenter="ui.showControls = true"
      @mouseleave="ui.showControls = false"
    >
      <div v-show="ui.isLoading" class="telemedicine__waiting">
        <span>Aguardando o seu paciente se conectar...</span>
        <dr-loader size="lg" class="telemedicine__loader" />
      </div>

      <div v-show="!ui.isLoading" class="telemedicine__placeholder">
        <share-link
          v-if="returnShareLink"
          header="Link para videoconferência"
          body="Compartilhe o link abaixo para o paciente acessar a videoconferência"
          :active="modalActive"
          :url.sync="returnShareLink"
          @close="modalActive = false"
        />

        <transition name="fade">
          <telemedicine-video
            v-if="token"
            v-show="ui.isBroadcasting"
            :token.sync="token"
          />
        </transition>

        <div
          :class="{ '!top-0': viewport.name === 'mobile' }"
          class="telemedicine-buttons"
        >
          <button @click="modalActive = true" class="btn btn-sm btn-default">
            Compartilhar link
          </button>

          <button class="btn btn-sm btn-primary" @click="openTelemedicineNewTab">
            Vídeo em nova aba
          </button>
        </div>

        <transition name="fade_up">
          <div v-show="!ui.isLoading && ui.showControls" class="telemedicine__controls">
            <button
              class="telemedicine__button"
              @mouseenter="ui.isMicBtnHover = true"
              @mouseleave="ui.isMicBtnHover = false"
              @click="
                toggleAudio();
                ui.isMicOn = !ui.isMicOn;
              "
            >
              <dr-icon
                :name="(ui.isMicOn) ? 'micOn' : 'micOff'"
                :fill.sync="ui.isMicBtnHover ? 'white' : 'blue'"
                class="telemedicine__button-icon"
              />
            </button>

            <button
              class="telemedicine__button"
              @mouseenter="ui.isVidBtnHover = true"
              @mouseleave="ui.isVidBtnHover = false"
              @click="
                toggleVideo();
                ui.isVidOn = !ui.isVidOn;
              "
            >
              <dr-icon
                :name="(ui.isVidOn) ? 'videoOn' : 'videoOff'"
                :fill.sync="ui.isVidBtnHover ? 'white' : 'blue'"
                class="telemedicine__button-icon"
              />
            </button>

            <button
              class="telemedicine__button"
              @mouseenter="ui.isDisconnectBtnHover = true"
              @mouseleave="ui.isDisconnectBtnHover = false"
              @click="finishTelemedicineAppointment()"
            >
              <dr-icon
                :fill.sync="ui.isDisconnectBtnHover ? 'white' : 'blue'"
                name="disconnect"
                class="telemedicine__button-icon"
              />
            </button>

            <button
              class="telemedicine__button"
              @mouseenter="ui.isFullscreenBtnHover = true"
              @mouseleave="ui.isFullscreenBtnHover = false"
              @click="toggleFullscreen()"
            >
              <dr-icon
                :fill.sync="ui.isFullscreenBtnHover ? 'white' : 'blue'"
                name="fullscreen"
                class="telemedicine__button-icon"
              />
            </button>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShareLink from '@/components/modals/shareLink'
import TelemedicineVideo from './telemedicineVideo'
import EventBus from '@/globals/eventBus'

export default {
  name: 'DrAppointmentTelemedicine',

  components: {
    TelemedicineVideo,
    ShareLink
  },

  data () {
    return {
      EventBus,
      modalActive: false,
      ui: {
        isStarted: false,
        isLoading: true,
        showControls: false,
        isMicOn: true,
        isMicBtnHover: false,
        isVidOn: true,
        isVidBtnHover: false,
        isDisconnectBtnHover: false,
        isFullscreen: false,
        isFullscreenBtnHover: false,
        isMedicalRecordOpen: true,
        isBroadcasting: false
      },
      destroy: false,
      token: null,
      path: null
    }
  },

  computed: {
    ...mapGetters({
      viewport: 'getViewport'
    }),

    isCurrentPath () {
      return (this.$route.path === this.path)
    },

    currentAppointmentId () {
      if (this.$store.getters.getActiveAppointments.length > 0) {
        return this.$store.getters.getActiveAppointments[0].id
      }

      return false
    },

    currentAppointmentUuid () {
      if (this.$store.getters.getActiveAppointments.length > 0) {
        return this.$store.getters.getActiveAppointments[0].uuid
      }

      return false
    },

    returnShareLink () {
      // return `https://paciente.${window.location.origin.split('://')[1]}/login/${this.currentAppointmentUuid}`
      return `${process.env.LINK_TELEMEDICINE}/login/${this.currentAppointmentUuid}`
    }

  },

  watch: {
    '$route.path': {
      deep: false,
      immediate: false,
      handler () {
        if (!this.isCurrentPath && this.viewport.name !== 'mobile') {
          this.minimizeContainer()
        }
      }
    },

    'ui.isStarted': {
      deep: false,
      immediate: true,
      handler () {
        this.$store.dispatch('setTelemedicineActive', this.ui.isStarted)
      }
    }
  },

  created () {
    window.addEventListener('scroll', () => {
      if (this.ui.isStarted && this.viewport.name !== 'mobile') {
        if (this.isCurrentPath && this.ui.isStarted) {
          if (Number(window.pageYOffset) >= 64) {
            this.minimizeContainer()
          } else {
            this.resizeContainer()
            this.stickContainer()
          }
        }
      }
    })

    EventBus.$on(
      'start-telemedicine-appointment',
      payload => this.startStream(payload)
    )

    EventBus.$on(
      'resize-telemedicine-container',
      () => window.setTimeout(() => {
        if (this.isCurrentPath && this.viewport.name !== 'mobile') {
          this.buildContainer()
        }
      }, 200)
    )

    EventBus.$on(
      'attach-telemedicine-screen',
      () => {
        if (this.ui.isStarted && this.isCurrentPath && this.viewport.name !== 'mobile') {
          this.$nextTick(() => {
            this.buildContainer()
          })
        }
      }
    )

    EventBus.$on(
      'telemedicine-started',
      () => {
        this.ui.isLoading = false
        this.ui.isBroadcasting = true
      }
    )

    EventBus.$on(
      'telemedicine-destroyed',
      () => this.destroyComponent()
    )

    window.addEventListener('resize', () => {
      if (this.isCurrentPath) {
        this.buildContainer()
      }
    })

    EventBus.$on(
      'telemedicine-finish',
      () => this.finishTelemedicineAppointment()
    )

    EventBus.$on(
      'telemedicine-zindex',
      (payload) => {
        this.$nextTick(() => {
          const container = document.querySelector('.telemedicine') || null
          if (container) {
            container.style.zIndex = payload.zIndex
          }
        })
      }
    )
  },

  methods: {
    destroyComponent () {
      this.ui.isStarted = false
      this.ui.isLoading = true
      this.ui.showControls = false
      this.ui.isMicOn = true
      this.ui.isMicBtnHover = false
      this.ui.isVidOn = true
      this.ui.isVidBtnHover = false
      this.ui.isDisconnectBtnHover = false
      this.ui.isFullscreen = false
      this.ui.isFullscreenBtnHover = false
      this.ui.isMedicalRecordOpen = true
      this.ui.isBroadcasting = false
      this.destroy = true
      this.token = null
      this.path = null

      const wrapper = document.querySelector('article.section')
      wrapper.style.paddingTop = '0'

      document.querySelector('#medical-record-header').style.paddingTop = '40px'
    },

    finishTelemedicineAppointment () {
      if (this.currentAppointmentId) {
        const url = `/agenda/${this.currentAppointmentId}/agenda_telemedicine/stop`
        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            console.log(res)
          })
          .catch(err => console.log(err))

        EventBus.$emit('telemedicine-disconnect')
        const medicalRecordHeader = document.querySelector('#medical-record-header')
        medicalRecordHeader.style.paddingTop = '40px'
      }
    },

    toggleAudio () {
      EventBus.$emit('telemedicine-toggle-audio', this.ui.isMicOn)
    },

    toggleVideo () {
      EventBus.$emit('telemedicine-toggle-video', this.ui.isVidOn)
    },

    toggleFullscreen () {
      if (this.ui.isFullscreen) {
        this.ui.isFullscreen = false
        document.exitFullscreen()
      } else {
        this.ui.isFullscreen = true
        this.$refs['telemedicine-container'].requestFullscreen()
      }
    },

    disconnect () {
      EventBus.$emit('telemedicine-disconnect')
    },

    minimizeContainer () {
      this.$nextTick(() => {
        const container = this.$refs['telemedicine-container']
        if (container) {
          container.style.position = 'fixed'
          container.style.height = '15vw' // '200px'
          container.style.width = '27vw' // '360px'
          container.style.left = '0'
          container.style.top = '0'
          container.style.transform = 'translate(0, calc(100vh - 15vw))'

          if (!this.isCurrentPath) {
            container.style.cursor = 'pointer'
          }
        }

        if (this.isCurrentPath) {
          const medicalRecordHeader = document.querySelector('#medical-record-header')
          medicalRecordHeader.style.paddingTop = '40px'
        }
      })
    },

    startStream (payload) {
      this.destroy = false
      this.token = payload.token
      this.path = payload.path
      this.ui.isStarted = true
      this.$nextTick(() => {
        this.buildContainer()
      })
    },

    buildContainer () {
      this.$nextTick(() => {
        this.resizeContainer()
        this.stickContainer()

        if (this.ui.isStarted && this.viewport.name !== 'mobile') {
          document.getElementById('app').addEventListener('scroll', ($event) => {
            if (this.isCurrentPath && this.ui.isStarted) {
              if ($event.target.scrollTop >= 64) {
                this.minimizeContainer()
              } else {
                this.resizeContainer()
                this.stickContainer()
              }
            }
          })
        }
      })
    },

    resizeContainer () {
      this.$nextTick(() => {
        const medicalRecordHeader = document.querySelector('#medical-record-header')
        const container = this.$refs['telemedicine-container']

        const width = this.viewport.name === 'mobile'
          ? document.documentElement.clientWidth
          : medicalRecordHeader.offsetWidth

        const height = this.viewport.name === 'mobile'
          ? document.documentElement.clientHeight * 0.6
          : width / 1.77

        if (container) {
          container.style.width = `${width}px`
          container.style.height = `${height}px`
        }
      })
    },

    stickContainer () {
      this.$nextTick(() => {
        const sidebarHeader = document.querySelector('#appointment-sidebar-header')
        const medicalRecordHeader = document.querySelector('#medical-record-header')
        const container = this.$refs['telemedicine-container']
        const width = medicalRecordHeader.offsetWidth
        const height = this.viewport.name === 'mobile'
          ? document.documentElement.clientHeight * 0.6
          : width / 1.77

        if (this.viewport.name === 'mobile') {
          const height = document.querySelector('#header-mobile').offsetHeight

          container.style.cursor = 'default'
          container.style.transform = 'unset'
          container.style.position = 'fixed'
          container.style.top = `${parseInt(height, 10)}px`
          container.style.left = '0'

          const wrapper = document.querySelector('article.section')
          wrapper.style.paddingTop = `${(document.documentElement.clientHeight * 0.6)}px`
          return
        }

        container.style.cursor = 'default'
        container.style.transform = 'unset'
        container.style.position = 'fixed'
        container.style.top = `${medicalRecordHeader.offsetTop}px`
        container.style.left = `${medicalRecordHeader.offsetLeft}px`
        medicalRecordHeader.style.paddingTop = `calc(${height}px + 1rem)`
      })
    },

    openTelemedicineNewTab () {
      window.open(`${process.env.LINK_TELEMEDICINE}/doctor/${this.token}`, '_blank')
      EventBus.$emit('telemedicine-destroyed')
      this.destroyComponent()
    }
  }
}
</script>
